import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { LoadingPanel } from "../../LoadingPanel";
import { addNotificationWithTimeout } from '../../../app/addNotificationWithTimeout';
import { handleResponse } from '../../../app/handleResponse';
import { getCSRFToken } from '../../../app/getCSRFToken';
import {
    Grid,
    GridColumn as Column,
} from "@progress/kendo-react-grid";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";

export const AdministratorVenueEventAlertLogs = (props) => {
    const dispatch = useDispatch();

    const [venueEventAlertLogs, setVenueEventAlertLogs] = useState([]);
    const [venueEventAlertLogCount, setVenueEventAlertLogCount] = useState(0);
    const [skipCount, setSkipCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(1);
    const [areVenueEventAlertLogsLoading, setAreVenueEventAlertLogsLoading] = useState(true);
    const [loadingError, setLoadingError] = useState("");

    const [showDialog, setShowDialog] = useState(false);
    const [dialogContent, setDialogContent] = useState("");

    const ViewDialogCell = (props) => {  
        const content = props.dataItem[props.field];
        
        return (
            <td>
                {content ? <Button fillMode="link" type={"button"} onClick={() => viewDialog(content)}>View</Button> : ""}
            </td>
        );
    };

    const viewDialog = (content) => {
        setDialogContent(content);
        setShowDialog(true);
    }

    const getVenueEventAlertLogs = (newPageNumber) => {
        setAreVenueEventAlertLogsLoading(true);

        const dataItem = {
            venueEventAlertKey: props.venueEventAlertKey,
            pageNumber: newPageNumber,
        };
    
        fetch(`/api/administrator/venueeventalertlogs`,
            {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                    "X-XSRF-TOKEN": getCSRFToken(),
                },
                body: JSON.stringify(dataItem),
            })
            .then(handleResponse)
            .then(result => {
                setAreVenueEventAlertLogsLoading(false);                
                setItemsPerPage(result.venueEventAlertLogsPerPage);
                setSkipCount(result.venueEventAlertLogsPerPage * (result.pageNumber - 1));
                setVenueEventAlertLogCount(result.totalVenueEventAlertLogCount);                
                setVenueEventAlertLogs(result.venueEventAlertLogs);
            })
            .catch(error => {
                addNotificationWithTimeout(dispatch, "error", error.message);

                setAreVenueEventAlertLogsLoading(false);
                setLoadingError(error.message);
            });
    }

    const pageChange = (event) => {
        const newPageNumber = (event.page.skip / event.page.take) + 1;
        getVenueEventAlertLogs(newPageNumber);
    };

    useEffect(() => {
        if (props.venueEventAlertKey) {
            getVenueEventAlertLogs();
        }
    }, []);

    return (
        <div>
            {areVenueEventAlertLogsLoading ? <LoadingPanel /> : (loadingError === "" ? (
                <>
                    <Grid
                        data={venueEventAlertLogs}
                        resizable={true}
                        skip={skipCount}
                        take={itemsPerPage}
                        total={venueEventAlertLogCount}
                        pageable={true}
                        onPageChange={pageChange}
                        scrollable="none"
                    >
                        <Column field="dateCreated" title={"Date"} />
                        <Column field="isAlertSuccessful" title={"Successful"} />
                        <Column field="ticketCount" title={"Ticket Count"} />
                        <Column field="notes" title={"Notes"} cell={ViewDialogCell} />
                    </Grid>

                    {showDialog === false ? <></> :
                        <Dialog
                            title={"Notes"}
                            onClose={() => setShowDialog(false)}
                            width={"90vw"}
                        >
                            {dialogContent}
                        </Dialog>
                    }
                </>
            ) : <></>)
            }
        </div>
    );
}